import { render, staticRenderFns } from "./NdcList.vue?vue&type=template&id=008593de"
import script from "./NdcList.vue?vue&type=script&lang=js"
export * from "./NdcList.vue?vue&type=script&lang=js"
import style0 from "./NdcList.vue?vue&type=style&index=0&id=008593de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports